import { change } from 'redux-form'

import { SEARCH_FILTERS_FORM } from '../../constants'
import updateRemovedRooms from './updateRemovedRooms'
import filterChange from './filterChange'

const removeRoom = (id, dispatch, state) => {
  const {
    main: {
      basket,
    },
    form: {
      searchFilters: {
        rooms,
        removedRooms,
      },
    },
  } = state
  const newRooms = rooms
  const index = rooms.findIndex(room => room.id === id)
  const room = {
    adults: 1,
    children: 0,
    babies: 0,
    id: id,
  }

  const basketApartments = basket ? basket.apartments : null

  Object.entries(room).forEach(r => dispatch(change(SEARCH_FILTERS_FORM, `${r[0]}_${index}`, `${r[1]}`)))
  room.visible = false

  newRooms[index] = room

  if (basketApartments && index < basketApartments.length) {
    dispatch(updateRemovedRooms(`${removedRooms}${removedRooms.length ? `,${index}` : `${index}`}`))
  }

  dispatch(filterChange('rooms', newRooms))
}

export default id => (dispatch, getState) => removeRoom(id, dispatch, getState())
